import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStageReach = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_74_156)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.7841 42.6667C16.3037 39.3453 18.9141 36.6439 22.1814 35.0112C25.4487 33.3785 29.1762 32.9129 32.7447 33.6916C36.3133 34.4704 39.5079 36.4466 41.798 39.2921C44.088 42.1375 45.3356 45.6808 45.3334 49.3333H36.0001",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.3334 19.3333C19.3334 21.9854 20.3869 24.529 22.2623 26.4043C24.1377 28.2797 26.6812 29.3333 29.3334 29.3333C31.9855 29.3333 34.5291 28.2797 36.4044 26.4043C38.2798 24.529 39.3334 21.9854 39.3334 19.3333C39.3334 16.6811 38.2798 14.1375 36.4044 12.2622C34.5291 10.3868 31.9855 9.33325 29.3334 9.33325C26.6812 9.33325 24.1377 10.3868 22.2623 12.2622C20.3869 14.1375 19.3334 16.6811 19.3334 19.3333V19.3333Z",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.6667 19.3333C44.6667 21.9854 45.7203 24.529 47.5957 26.4043C49.471 28.2797 52.0146 29.3333 54.6667 29.3333C57.3189 29.3333 59.8625 28.2797 61.7378 26.4043C63.6132 24.529 64.6667 21.9854 64.6667 19.3333C64.6667 16.6811 63.6132 14.1375 61.7378 12.2622C59.8625 10.3868 57.3189 9.33325 54.6667 9.33325C52.0146 9.33325 49.471 10.3868 47.5957 12.2622C45.7203 14.1375 44.6667 16.6811 44.6667 19.3333V19.3333Z",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.6134 35.5039C49.0451 34.0874 51.8073 33.3374 54.6215 33.3294C57.4356 33.3214 60.202 34.0558 62.6417 35.4585C65.0814 36.8612 67.1079 38.8825 68.5169 41.3185C69.9259 43.7545 70.6674 46.5191 70.6667 49.3332H50.6667",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33337 49.3333V70.6666",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M49.3334 68C49.3334 65.8783 48.4905 63.8434 46.9902 62.3431C45.4899 60.8429 43.4551 60 41.3334 60H31.3334C31.3334 57.8783 30.4905 55.8434 28.9902 54.3431C27.4899 52.8429 25.4551 52 23.3334 52H9.33337V68H49.3334Z",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.3334 60H31.3334",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_74_156",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			fill: "white",
			transform: "translate(8 8)"
		})
	}) })]
});
export default SvgIconStageReach;
